<template>
    <UserActivityTile @click="tileClicked()" :userActivity="userActivity">


        <template v-slot:title>{{ userActivity.body.offerName }}</template>
        <template v-slot:subtitle>{{ userActivity.username }}</template>



        <template v-slot:append-item-right>
            <UserActivityCoinChip>
                {{ $abbreviateNumber(userActivity.body.coinsAmount) }}
            </UserActivityCoinChip>
        </template>



    </UserActivityTile>
</template>



<script lang="ts" setup>

import { useRouter } from 'vue-router';
import { PropType } from 'vue';
import { IOfferUserActivity } from '@/interfaces/UserActivity/IOfferUserActivity';

import UserActivityTile from './UserActivityTile.vue';
import UserActivityCoinChip from '@/components/UserActivity/UserActivityTileElements/UserActivityCoinChip.vue';

const props = defineProps({
    userActivity: {
        type: Object as PropType<IOfferUserActivity>,
        required: true,
    },
});

const router = useRouter();

const tileClicked = () => {
    router.push('/earn');
}

</script>
